<template>
  <div v-if="ready" class="result">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="pay">
      <template>
        <div :class="['pay-content', floor_price ? '' : 'origin']">
          <div class="pay-status">
            <div class="pay-logo-wrap">
              <img src="@/assets/image/bargin/success.png" class="pay-logo" />
            </div>
            <div class="pay-res">支付成功</div>
            <div class="pay-subtitle">
              {{
                all_payed
                  ? "订单已完成支付，您可以进入群聊继续交易"
                  : "诚意买订单已完成支付，可继续查看底价或发起议价"
              }}
            </div>
          </div>
          <div v-if="floor_price && !all_payed" class="floor-price">
            <div class="price-group">
              <div :class="['bg-fire', checkFloor ? 'box-move' : '']">
                <div
                  :class="['picture', checkFloor ? 'picture-move' : '']"
                ></div>
                <div :class="['word', checkFloor ? 'check-floor' : '']">
                  底价
                </div>
              </div>
              <div class="price-group-title">
                <img src="@/assets/image/bargin/bargin-logo.png" alt="" />
                <span>卖家底价</span>
              </div>
              <div class="describe">该价格是卖家已同意成交的最低价</div>
              <div class="bottom">
                <div class="bottom-price">
                  <span class="suffix">¥</span>
                  <span class="price">{{ price ? price : "???" }}</span>
                  <span class="price-origin"
                    >原价：¥{{ product_info.product_price }}</span
                  >
                </div>
                <div :class="['btn', price ? 'buy' : 'view']" @click="goCheck">
                  <img src="@/assets/image/bargin/light.png" alt="" />
                </div>
              </div>
            </div>
            <div class="pay-tip"></div>
          </div>
          <div v-else class="pay-tip tips">
            {{
              all_payed
                ? "订单已完成支付"
                : "诚意买订单已完成支付，点击下方按键去议价吧～"
            }}
          </div>
          <template v-if="all_payed">
            <el-button class="floor-buy" @click="checkAcount">{{
              btnText
            }}</el-button>
          </template>
          <template v-else>
            <el-button
              :class="['discuss', floor_price ? '' : 'floor-buy']"
              @click="goBarginList"
              >去议价</el-button
            >
          </template>
        </div>
      </template>
      <my-dialog
        :show="changeShow"
        title="温馨提醒"
        text="<div>该商品内容已变动，请重新发起求降价！</div><div>将为您进行自动退款！</div>"
        btnText="确认"
        :btnFuc="redirect"
        :closeFun="() => (changeShow = false)"
      ></my-dialog>
    </div>
  </div>
</template>

<script>
import {
  checkFloorPrice,
  currentPrice,
  earnestDetail,
  earnestFloor,
} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import myDialog from "@/components/myDialog.vue";
export default {
  data() {
    return {
      floor_price: false,
      checkFloor: false,
      second: 3,
      timer: null,
      order_id: "",
      // 底价
      price: "",
      product_info: {},
      ready: false,
      changeShow: false,
      err_code: "",
    };
  },
  computed: {
    breadcrumbList() {
      return [
        {
          name: "全部游戏",
          link: "/allGame",
        },
        {
          name: this.product_info.game_name,
          link: "/selectGame",
          query: {
            game_id: this.$route.query.game_id,
            game_alias:
              this.$route.query.game_id == "26" ? "yuanshen5" : "games",
          },
        },
        {
          name: "账号详情",
          link: "/gamedetails",
          query: {
            game_id: this.$route.query.game_id,
            id: this.$route.query.id,
            source_page: "home",
          },
        },
        {
          name: "支付确认",
        },
      ];
    },
    btnText() {
      return `进群`;
    },
    all_payed() {
      return (
        this.product_info.tail_order_pay_time !== null &&
        this.product_info.status === 0
      );
    },
  },
  components: { breadcrumb, myDialog },
  watch: {
    // all_payed: {
    //   handler(val) {
    //     if (val) {
    //       this.$nextTick(() => {
    //         this.timer = setInterval(() => {
    //           this.second--;
    //           if (this.second === 0) {
    //             clearInterval(this.timer);
    //             // this.goBarginList();
    //             this.goGroup()
    //           }
    //         }, 1000);
    //       });
    //     }
    //   },
    // },
  },
  async created() {
    this.order_id = this.$route.query.orderid;
    //  查询诚意买订单详情
    let _res = await earnestDetail({ order_id: this.order_id }).catch((err) => {
      this.$message.error(err.msg);
      if (err?.code === 10012 || err?.code === 10013) {
        this.err_code = err.code;
        this.changeShow = true;
        return;
      }
    });
    this.product_info = _res.data;
    // 是否有底价
    let res = await currentPrice({ order_id: this.order_id }).catch((err) => {
      this.$message.error(err.msg);
      if (err?.code === 10012 || err?.code === 10013) {
        this.err_code = err.code;
        this.changeShow = true;
        return;
      }
    });
    this.floor_price = res.data.get_reserve_price;
    this.ready = true;
  },
  methods: {
    // 重定向
    redirect() {
      switch (this.err_code) {
        case 10012:
          this.$router.push({
            path: "/gamedetails",
            query: {
              game_id: this.product_info.game_id,
              id: this.product_info.product_id,
            },
          });
          break;
        case 10013:
          this.$router.push({
            name: "SelectGame",
            query: {
              game_id: this.product_info.game_id,
              game_alias:
                this.product_info.game_id == "26" ? "yuanshen5" : "games",
            },
          });
          break;
      }
    },
    // 查看底价  或者底价购买
    goCheck() {
      if (!this.price) {
        checkFloorPrice({ order_id: this.order_id })
          .then((res) => {
            if (res.code === 200) {
              this.price = res.data.price;
              if (this.price === 0) {
                this.$message({
                  message: "底价已失效！",
                  type: "error",
                });
                this.goBarginList();
              } else {
                this.checkFloor = true;
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
            if (err?.code === 10012 || err?.code === 10013) {
              this.redirect(err?.code);
            }
          });
      } else {
        this.floorBuy();
      }
    },
    // 验号
    checkAcount() {
      // if (this.timer) clearInterval(this.timer);
      // this.goBarginList();
      this.goGroup()
    },
    goGroup() {
      this.$openIM({
        im_type: 3,
        roomId: this.product_info.group_room_id,
      });
    },
    goBarginList() {
      this.$router.push({
        path: "/personalCenter/buyer/bargainPrice",
      });
    },
    floorBuy() {
      earnestFloor({ order_id: this.product_info.id })
        .then((res) => {
          let { href } = this.$router.resolve({
            name: "OnlineDeal",
            query: {
              id: this.product_info.product_id,
              game_id: this.product_info.game_id,
              earnest_order_id: this.product_info.id,
            },
          });
          window.open(href, "_blank");
        })
        .catch((err) => {
          if (err?.code === 10012 || err?.code === 10013) {
            this.redirect(err?.code);
          }
          this.$message.error(err.msg);
        });
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.result {
  width: 1200px;
  max-width: calc(100vw - 48px);
  margin: 0 auto;
  padding: 0 0 40px;
  box-sizing: border-box;
  font-family: PingFang SC, PingFangSC-Regular, "Microsoft YaHei", sans-serif;
  color: var(--text-main, #111827);

  /deep/ .title {
    width: 100%;
  }

  .pay {
    width: 100%;
    min-height: 640px;
    padding: 56px 32px 64px;
    background: var(--bg-card, #ffffff);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    box-sizing: border-box;
    text-align: center;
    overflow: visible;

    .pay-content {
      width: 100%;
      min-height: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      .pay-status {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 34px;
      }

      .pay-logo-wrap {
        width: 92px;
        height: 92px;
        border-radius: 50%;
        background: var(--success-soft, #ECFDF5);
        border: 1px solid rgba(34, 197, 94, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 12px 28px rgba(34, 197, 94, 0.12);
      }

      .pay-logo {
        width: 64px;
        height: 64px;
        display: block;
      }

      .pay-res {
        margin-top: 18px;
        color: var(--text-main, #111827);
        font-size: 28px;
        line-height: 40px;
        font-weight: 600;
      }

      .pay-subtitle {
        min-height: 22px;
        margin-top: 8px;
        color: var(--text-secondary, #5A5F6B);
        font-size: 14px;
        line-height: 22px;
      }

      .floor-price {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .price-group {
          position: relative;
          width: 460px;
          min-height: 190px;
          padding: 28px 28px 26px;
          margin: 0 auto;
          background: linear-gradient(180deg, #F7F5F2 0%, #FFFFFF 100%);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: 0 16px 36px rgba(26, 29, 36, 0.1);
          box-sizing: border-box;

          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            border-radius: 4px 4px 0 0;
            background: var(--primary, #FF5A1F);
          }

          .bg-fire {
            position: absolute;
            width: 80px;
            right: 28px;
            top: -50px;
            transition: top 0.3s linear;
            &.box-move {
              top: -30px;
            }
            .picture {
              height: 90px;
              width: 100%;
              margin: auto;
              background-image: url("~@/assets/image/bargin/arrow.png");
              background-repeat: no-repeat;
              background-size: 100% auto;
              transition: all 0.3s steps(29);
              &.picture-move {
                background-position-y: -3190px;
              }
            }
            .word {
              text-align: center;
              font-weight: 400;
              color: var(--primary, #FF5A1F);
              font-size: 12px;
              transform: scale(0.9);
              opacity: 0;
              transition: opacity 0.3s linear;
            }
            .check-floor {
              opacity: 1;
            }
          }
          &-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            img {
              width: 20px;
              height: 20px;
            }

            span {
              color: var(--text-main, #1A1D24);
              font-size: 16px;
              font-weight: 500;
              margin-left: 4px;
            }
          }

          .describe {
            color: var(--text-secondary, #5A5F6B);
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            line-height: 20px;
            margin-top: 6px;
          }

          .bottom {
            min-height: 58px;
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;

            .bottom-price {
              align-self: flex-end;
              min-width: 0;
              text-align: left;
            }

            .suffix,
            .price {
              font-size: 14px;
              font-weight: 500;
              color: var(--primary, #FF5A1F);
            }

            .price {
              font-size: 30px;
              line-height: 38px;
            }

            .price-origin {
              color: var(--text-muted, #9AA0AC);
              margin-left: 10px;
              text-decoration: line-through;
              font-size: 12px;
              font-weight: 400;
              white-space: nowrap;
            }

            .btn {
              width: 96px;
              height: 32px;
              flex: 0 0 96px;
              border-radius: 4px;
              background-position: -5px -2px;
              background-repeat: no-repeat;
              position: relative;
              overflow: hidden;
              cursor: pointer;
              transition: transform 0.2s ease, box-shadow 0.2s ease;

              &:hover {
                transform: translateY(-1px);
                box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
              }

              &:active {
                transform: translateY(0);
              }

              @keyframes move-x {
                0% {
                  left: -30px;
                }
                100% {
                  left: 200px;
                }
              }
              img {
                height: 50px;
                width: 50px;
                position: absolute;
                top: -10px;
                animation: move-x 1.8s linear infinite;
              }
              &.view {
                background-image: url("~@/assets/image/bargin/btn-view.png");
              }
              &.buy {
                background-image: url("~@/assets/image/bargin/btn-buy.png");
              }
            }
          }
        }
      }

      .el-button {
        font-weight: 500;
        font-size: 16px;
        height: 50px;
        color: #ffffff;
        border-radius: 3px;
        transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease,
          background 0.2s ease;

        &:hover,
        &:focus {
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .discuss:not(.floor-buy) {
        width: 260px;
        color: var(--text-main, #1A1D24);
        border: 1.5px solid var(--bg-dark, #1A1D24);
        background: var(--bg-card, #ffffff);

        &:hover,
        &:focus {
          color: var(--text-main, #1A1D24);
          border-color: var(--bg-dark, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
          box-shadow: 0 10px 22px rgba(26, 29, 36, 0.12);
        }
      }

      .discuss.floor-buy {
        color: #ffffff;
        border-color: transparent;
        background: var(--primary, #FF5A1F);
      }

      .floor-buy {
        width: 260px;
        background: var(--primary, #FF5A1F);
        border-color: transparent;

        &:hover,
        &:focus {
          color: #ffffff;
          background: var(--primary-hover, #E84A12);
          border-color: transparent;
          box-shadow: 0 12px 24px rgba(255, 90, 31, 0.22);
        }
      }
    }

    .pay-tip {
      min-height: 33px;
      font-size: 14px;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      letter-spacing: 0;
      line-height: 22px;

      &.tips {
        height: auto;
        margin: 0 0 34px;
        padding: 12px 18px;
        color: var(--text-secondary, #5A5F6B);
        background: var(--bg-card-soft, #F0EDE8);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
      }

      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }
  }
}
.origin {
  justify-content: center !important;

  .pay-res {
    margin-bottom: 0 !important;
  }

  .pay-tip {
    margin: 0 auto 34px !important;
  }
}

@media screen and (max-width: 768px) {
  .result {
    max-width: calc(100vw - 24px);

    .pay {
      padding: 40px 16px 48px;
      min-height: 560px;

      .pay-content {
        min-height: 460px;

        .floor-price {
          .price-group {
            width: 100%;
            padding: 28px 18px 24px;

            .bg-fire {
              right: 16px;
            }

            .bottom {
              align-items: flex-start;
              flex-direction: column;

              .btn {
                align-self: flex-end;
              }
            }
          }
        }

        .discuss,
        .floor-buy {
          width: 100%;
          max-width: 260px;
        }
      }
    }
  }
}
</style>
